import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {paths} from '@mintdata-wsp/wsp/ui/routes/Routing';
import {
    IWspSidebarLink,
    WspSidebar,
    WspSidebarLink
} from '@mintdata-wsp/wsp/ui/views/workspace/home/sidebar/WspSidebar';
import * as classnames from 'classnames/bind';
import {computed} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {NavLink} from 'react-router-dom';

const styles = require('./SidebarLink.less');
const cx = classnames.bind(styles);

interface Props
{
    sidebarLink:WspSidebarLink,
    className?:any
    wrapperClassName?:any
    iconClassName?:any
}

@observer
export class SidebarLink extends React.Component<Props, any>
{
    @computed
    private get link():IWspSidebarLink
    {
        const {sidebarLink} = this.props;

        return WspSidebar.wspSidebarLinks[sidebarLink];
    }

    // private checkActive = (match, location) =>
    // {
    //     const pageMatch = rootState.ui.mainPage.match;
    //
    //     const {sidebarLink} = this.props;
    //     const link = WspSidebar.wspSidebarLinks[sidebarLink];
    //
    //     if( !match || !location || !link.url ) return false;
    //
    //     // const {pathname} = location;
    //     // return pathname === link.url;
    //     return match.url === link.url;
    // };

    private _onClick = (e:React.MouseEvent<HTMLElement>) =>
    {
        if( !this.link ) return;

        if( this.link.onClick )
        {
            // e.preventDefault();
            this.link.onClick(e);
            return;
        }

        if( this.link.url && this.link.openInNewTab )
        {
            e.preventDefault();
            window.open(this.link.url);
            return;
        }

        controllers.ui.mainPage.setMobileMenuVisibility(false);
    };

    // private _isActive = (match:any, location:any) =>
    // {
    //     return (match && match.params && match.params.templateName) ? true : undefined;
    // };

    render():JSX.Element
    {
        // do not remove: need for update component
        const {locationMatch} = rootState.ui.mainPage;

        const {className, iconClassName, wrapperClassName} = this.props;

        if( !this.link ) return null;

        const Icon = ():JSX.Element =>
        {
            return (
                <span className={styles.linkIconWrapper}>
                    {
                        this.link.icon &&
                        <MDIcon
                            className={cx(styles.linkIcon, iconClassName)}
                            name={this.link.icon}
                        />
                    }
                </span>
            );
        };

        const isTemplatePage:boolean = locationMatch && locationMatch.params && locationMatch.params.templateName;

        const active:boolean = isTemplatePage && this.link.url === paths.templates();

        return (
            <div className={cx(styles.linkWrapper, wrapperClassName)}>
                {
                    (this.link.url || this.link.onClick) &&
                    <NavLink
                        exact={true}
                        to={this.link.url ? this.link.url : '#'}
                        className={cx(styles.link, className, {active})}
                        activeClassName={styles.active}
                        onClick={this._onClick}
                        // isActive={this._isActive}
                    >
                        <Icon />
                        {this.link.title}
                    </NavLink>
                }
                {
                    !(this.link.url || this.link.onClick) &&
                    <span className={cx(styles.link, styles.text, className)}>
                        <Icon />
                        {this.link.title}
                    </span>
                }
            </div>
        );
    }
}
